import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import PageWelcome from './components/PageWelcome';
import PageOne from './components/PageOne';
import PageTwo from './components/PageTwo';
import PageThree from './components/PageThree';
import PageFour from './components/PageFour';
import PageFive from './components/PageFive';
import { LoseWeight, Energy, Immunity, Focus, Face, Eye, Smile, Gut, AntiAging, HeartHealth, Fruit, Shoe, PeriodHealth, ExcessHair, ImproveHair, HotFlash, SexualHealth, Sleep, Bone } from './icons/Icons';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import queryString from 'query-string';

const apiQuiz = 'https://app.get-nourished.com/api/klaviyo/quiz--uk';

const CoreQuiz = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [firstName, setFirstName] = useState('');
  const [gender, setGender] = useState('');
  const [age, setAge] = useState('');
  const [race, setRace] = useState('');
  const [suitableAge, setSuitableAge] = useState(true);
  const [weightingAnswers, setWeightingsAnswers] = useState([]);
  const [activeGoalsAnswer, setActiveGoalsAnswer] = useState([]);
  const [exerciseAnswersIndex, setExerciseAnswersIndex] = useState([]);
  const [travelAnswersIndex, setTravelAnswersIndex] = useState([]);
  const [specificDiet, setSpecificDiet] = useState('');
  const [dietAnswersIndex, setDietAnswersIndex] = useState([]);
  const [hungryBetweenMeals, setHungryBetweenMeals] = useState('');
  const [processedFoodAnswer, setProcessedFoodAnswer] = useState('');
  const [fruitVegAnswer, setFruitVegAnswer] = useState('');
  const [alcoholAnswersIndex, setAlcoholAnswersIndex] = useState([]);
  const [glassesAnswer, setGlassesAnswer] = useState('');
  const [iodineAnswer, setIodineAnswer] = useState('');
  const [medicationAnswer, setMedicationAnswer] = useState('');
  const [vitaminsAnswer, setVitaminsAnswer] = useState('');
  const [energySliderValue, setEnergySliderValue] = useState(50);
  const [activitySliderValue, setActivitySliderValue] = useState(50);
  const [sleepSliderValue, setSleepSliderValue] = useState(50);
  const [screenSliderValue, setScreenSliderValue] = useState(50);
  const [conditionsAnswerIndex, setConditionsAnswerIndex] = useState([]);
  const [conditionsEffectSlider, setConditionsEffectSlider] = useState(50);
  const [manageConditionsAnswerIndex, setManageConditionsAnswerIndex] = useState([]);
  const [natalAnswerIndex, setNatalAnswerIndex] = useState([]);
  const [selectedVitamins, setSelectedVitamins] = useState([]);
  const [flavour, setFlavour] = useState('');
  const [coating, setCoating] = useState('');
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [questionGA, setQuestionGA] = useState('');
  const [quizID, setQuizID] = useState('');

  useEffect(() => {
    const currentUrl = window.location.href;
    const activeStepUrl = queryString.stringifyUrl({ url: currentUrl, query: { page: `${pageIndex}` } });

    if (typeof ga !== 'undefined') {
      history.replaceState({}, null, activeStepUrl);
      ga('send', 'pageview', location.href);
    }
  }, [pageIndex]);

  const updateQuestionUrl = (value) => {
    const currentUrl = window.location.href;
    const activeStepUrl = queryString.stringifyUrl({ url: currentUrl, query: { page: `${pageIndex}-${value}` } });

    if (value !== questionGA && typeof ga !== 'undefined') {
      history.replaceState({}, null, activeStepUrl);
      ga('send', 'pageview', location.href);
    }
    setQuestionGA(value);
  }

  const updateFirstName = (answer) => {
    setFirstName(answer);
    updateQuestionUrl('first-name');
  }

  const genderAnswers = [
    {
      "name": "gender",
      "label": "Male",
      "value": "male"
    },
    {
      "name": "gender",
      "label": "Female",
      "value": "female"
    },
    {
      "name": "gender",
      "label": "Non-binary",
      "value": "NonBinary"
    },
    {
      "name": "gender",
      "label": "Prefer not to say",
      "value": "opt-out"
    }
  ];

  const raceAnswers = [
    {
      "name": "race",
      "label": "White",
      "value": "white"
    },
    {
      "name": "race",
      "label": "Mixed",
      "value": "mixed"
    },
    {
      "name": "race",
      "label": "Asian",
      "value": "asain"
    },
    {
      "name": "race",
      "label": "Black, African, Caribbean",
      "value": "blackAfricanCaribbean"
    },
    {
      "name": "race",
      "label": "Other",
      "value": "other"
    }
  ]

  const exerciseQuestion = {
    "answers": [
      {
        "label": "Running or cardio",
        "questionId": "exercise",
        "products": [
          {
            "b12": 5000
          },
          {
            "beetroot-powder": 2000
          },
          {
            "cordyceps": 5000
          },
          {
            "hydrocurc-pepperine": 5000
          },
          {
            "k2-vital-delta": 2500
          },
          {
            "maca-powder": 1000
          },
          {
            "silica": 5000
          },
          {
            "tart-cherry": 99999
          }
        ]
      },
      {
        "label": "Weights",
        "questionId": "exercise",
        "products": [
          {
            "b12": 5000
          },
          {
            "beetroot-powder": 2000
          },
          {
            "cordyceps": 2000
          },
          {
            "hydrocurc-pepperine": 5000
          },
          {
            "k2-vital-delta": 2500
          },
          {
            "maca-powder": 2500
          },
          {
            "silica": 9999
          },
          {
            "tart-cherry": 99999
          }
        ]
      },
      {
        "label": "Classes",
        "questionId": "exercise",
        "products": [
          {
            "b12": 5000
          },
          {
            "beetroot-powder": 3000
          },
          {
            "cordyceps": 5000
          },
          {
            "hydrocurc-pepperine": 2500
          },
          {
            "k2-vital-delta": 2500
          },
          {
            "maca-powder": 2500
          },
          {
            "silica": 2000
          },
          {
            "tart-cherry": 5000
          }
        ]
      },
      {
        "label": "Organised sports",
        "questionId": "exercise",
        "products": [
          {
            "b12": 5000
          },
          {
            "beetroot-powder": 4000
          },
          {
            "cordyceps": 5000
          },
          {
            "hydrocurc-pepperine": 5000
          },
          {
            "k2-vital-delta": 2500
          },
          {
            "maca-powder": 5000
          },
          {
            "silica": 2000
          },
          {
            "tart-cherry": 99999
          }
        ]
      },
      {
        "label": "Crossfit",
        "questionId": "exercise",
        "products": [
          {
            "b12": 5000
          },
          {
            "beetroot-powder": 5000
          },
          {
            "cordyceps": 5000
          },
          {
            "hydrocurc-pepperine": 5000
          },
          {
            "k2-vital-delta": 2500
          },
          {
            "maca-powder": 5000
          },
          {
            "silica": 5000
          },
          {
            "tart-cherry": 5000
          }
        ]
      },
      {
        "label": "Boxing",
        "questionId": "exercise",
        "products": [
          {
            "b12": 5000
          },
          {
            "beetroot-powder": 6000
          },
          {
            "cordyceps": 5000
          },
          {
            "hydrocurc-pepperine": 5000
          },
          {
            "k2-vital-delta": 2500
          },
          {
            "maca-powder": 5000
          },
          {
            "silica": 5000
          },
          {
            "tart-cherry": 99999
          }
        ]
      },
      {
        "label": "Walking",
        "questionId": "exercise",
        "products": [
          {
            "b12": 5000
          },
          {
            "beetroot-powder": 2000
          },
          {
            "cordyceps": 5000
          },
          {
            "k2-vital-delta": 2500
          },
          {
            "silica": 5000
          },
          {
            "tart-cherry": 5000
          }
        ]
      },
      {
        "label": "Other",
        "questionId": "exercise",
      },
      {
        "label": "None",
        "questionId": "exercise",
      }
    ]
  };

  const travelQuestion = {
    "answers": [
      {
        "label": "Never",
        "questionId": "travel",
        "products": [
          {
            "lactospore-probiotic": 1000
          }
        ]
      },
      {
        "label": "1-2 times a year",
        "questionId": "travel",
        "products": [
          {
            "lactospore-probiotic": 2000
          },
        ]
      },
      {
        "label": "2-5 times a year",
        "questionId": "travel",
        "products": [
          {
            "ashwagandha-extract": 2500
          },
          {
            "beta-glucan": 5000
          },
          {
            "hydrocurc-pepperine": 5000
          },
          {
            "lactospore-probiotic": 3000
          },
        ]
      },
      {
        "label": "5-10 times a year",
        "questionId": "travel",
        "products": [
          {
            "ashwagandha-extract": 5000
          },
          {
            "beta-glucan": 9999
          },
          {
            "ginger-extract": 4500
          },
          {
            "hydrocurc-pepperine": 7500
          },
          {
            "lycopene": 2000
          },
          {
            "lactospore-probiotic": 5000
          },
          {
            "resveratrol": 5000
          },
          {
            "tart-cherry": 5000
          }
        ]
      },
      {
        "label": "10 or more times a year",
        "questionId": "travel",
        "products": [
          {
            "ashwagandha-extract": 8000
          },
          {
            "b12": 99999
          },
          {
            "beta-glucan": 99999
          },
          {
            "ginger-extract": 9999
          },
          {
            "hydrocurc-pepperine": 9999
          },
          {
            "lycopene": 3000
          },
          {
            "lactospore-probiotic": 9998
          },
          {
            "resveratrol": 9999
          },
          {
            "tart-cherry": 9999
          },
        ]
      },
    ]
  };

  const alcoholQuestion = {
    "answers": [
      {
        "label": "Never",
        "questionId": "alcohol",
      },
      {
        "label": "Rarely",
        "questionId": "alcohol",
      },
      {
        "label": "Once or twice a month",
        "questionId": "alcohol",
        "products": [
          {
            "milk-thistle-extract": 2500
          },
          {
            "vitamin-a": 2500
          },
        ]
      },
      {
        "label": "Once or twice a week",
        "questionId": "alcohol",
        "products": [
          {
            "k2-vital-delta": 1000
          },
          {
            "milk-thistle-extract": 5000
          },
          {
            "vitamin-a": 5000
          },
          {
            "apple-cider-vinegar": 2500
          }
        ]
      },
      {
        "label": "Most nights",
        "questionId": "alcohol",
        "products": [
          {
            "ginger-extract": 5000
          },
          {
            "hydrocurc-pepperine": 7000
          },
          {
            "k2-vital-delta": 2000
          },
          {
            "milk-thistle-extract": 9999
          },
          {
            "lactospore-probiotic": 5000
          },
          {
            "vitamin-a": 9999
          },
          {
            "apple-cider-vinegar": 5000
          }
        ]
      },
    ]
  };

  const goalsQuestion = {
    "question": `What would you say is the number one goal for ${firstName}'s health for the next 3 months?`,
    "answers": [
      {
        "label": "Lose weight or tone up",
        "icon": "weight",
        "questionId": "goals",
        "products": [
          {
            "inositol": 9999
          },
          {
            "bpl1-ht": 99999
          },
          {
            "b12": 99999
          },
          {
            "careflow-mango-powder": 9999
          },
          {
            "folic-acid": 5000
          },
          {
            "white-kidney-extract": 99999
          },
          {
            "apple-cider-vinegar": 99999
          },
        ]
      },
      {
        "label": "More energy",
        "icon": "energy",
        "questionId": "goals",
        "products": [
          {
            "b12": 99999
          },
          {
            "beetroot-powder": 5000
          },
          {
            "coq10": 5000
          },
          {
            "cordyceps": 7000
          },
          {
            "folic-acid": 5000
          },
          {
            "ginseng": 9999
          },
          {
            "iron": 5000
          },
          {
            "maca-powder": 9999
          },
          {
            "tart-cherry": 99999
          },
          {
            "vitamin-c": 99999
          },
          {
            "iodine": 9999,
          }
        ]
      },
      {
        "label": "Better immunity",
        "icon": "immunity",
        "questionId": 'goals',
        "products": [
          {
            "b12": 50000
          },
          {
            "beta-glucan": 9999
          },
          {
            "folic-acid": 9999
          },
          {
            "ginger-extract": 2500
          },
          {
            "iron": 5000
          },
          {
            "lycopene": 5000
          },
          {
            "lactospore-probiotic": 9999
          },
          {
            "vegan-vitamin-d3": 9999
          },
          {
            "vitamin-a": 9999
          },
          {
            "vitamin-c": 9999
          },
          {
            "zinc": 9999
          }
        ]
      },
      {
        "label": "Better focus & memory",
        "icon": 'focus',
        "questionId": 'goals',
        "products": [
          {
            "ashwagandha-extract": 7000
          },
          {
            "5-htp": 2500
          },
          {
            "b12": 50000
          },
          {
            "coq10": 7000
          },
          {
            "folic-acid": 2500
          },
          {
            "ginseng": 5000
          },
          {
            "iron": 9999
          },
          {
            "maca-powder": 2500
          },
          {
            "milk-thistle-extract": 1000
          },
          {
            "resveratrol": 5000
          },
          {
            "zinc": 99999
          },
          {
            "iodine": 9999,
          },
          {
            "vitamin-a": 99999
          },
        ]
      },
      {
        "label": "Improve skin",
        "icon": "face",
        "questionId": 'goals',
        "products": [
          {
            "coq10": 2500
          },
          {
            "lycopene": 5000
          },
          {
            "resveratrol": 9999
          },
          {
            "selenium": 9999
          },
          {
            "silica": 99999
          },
          {
            "vitamin-c": 99999
          },
          {
            "vitamin-e": 7500
          },
          {
            "zinc": 9999
          },
          {
            "iodine": 5000,
          },
          {
            "vitamin-a": 9999
          },
        ]
      },
      {
        "label": "Healthier hair & nails",
        "icon": "improveHair",
        "questionId": 'goals',
        "products": [
          {
            "coq10": 9999
          },
          {
            "folic-acid": 7500
          },
          {
            "lycopene": 5000
          },
          {
            "selenium": 9999
          },
          {
            "silica": 99999
          },
          {
            "vitamin-c": 2500
          },
          {
            "iodine": 9999,
          },
          {
            "vitamin-a": 9999
          },
        ]
      },
      {
        "label": "Tackle excess hair",
        "icon": "excessHair",
        "questionId": 'goals',
        "products": [
          {
            "inositol": 9999999
          },
          {
            "coq10": 9999
          },
          {
            "vegan-vitamin-d3": 99999
          },
          {
            "zinc": 99999
          },
        ]
      },
      {
        "label": "Menstrual cycle health",
        "icon": "periodHealth",
        "questionId": 'goals',
        "nonMale": true,
        "products": [
          {
            "inositol": 99999
          }
        ]
      },
      {
        "label": "Reduce hot flashes & sweating",
        "icon": "hotFlash",
        "questionId": 'goals',
        "products": [
          {
            "ginseng": 99999
          },
          {
            "milk-thistle-extract": 99999
          },
        ]
      },
      {
        "label": "Gut health & digestion",
        "icon": "gut",
        "questionId": 'goals',
        "products": [
          {
            "ginger-extract": 9999
          },
          {
            "k2-vital-delta": 5000
          },
          {
            "lactospore-probiotic": 99999
          },
          {
            "vegan-vitamin-d3": 5000
          },
          {
            "apple-cider-vinegar": 99999
          }
        ]
      },
      {
        "label": "Increase libido / sexual health",
        "icon": "sexualHealth",
        "questionId": 'goals',
        "products": [
          {
            "ashwagandha-extract": 5000
          },
          {
            "lycopene": 5000
          },
          {
            "maca-powder": 99999
          },
          {
            "vegan-vitamin-d3": 5000
          },
          {
            "zinc": 999999
          },
        ]
      },
      {
        "label": "Improve sleep quality",
        "icon": "sleep",
        "questionId": 'goals',
        "products": [
          {
            "inositol": 5000
          },
          {
            "ashwagandha-extract": 9999
          },
          {
            "5-htp": 9999
          },
          {
            "selenium": 99999
          },
          {
            "tart-cherry": 99999
          },
        ]
      },
      {
        "label": "Bone & joint health",
        "icon": "bone",
        "questionId": 'goals',
        "products": [
          {
            "k2-vital-delta": 9999
          },
          {
            "lycopene": 5000
          },
          {
            "milk-thistle-extract": 9999
          },
          {
            "resveratrol": 99999
          },
          {
            "selenium": 9999
          },
          {
            "vegan-vitamin-d3": 9999
          },
          {
            "vitamin-c": 9999
          },
          {
            "zinc": 9999
          }
        ]
      },
      {
        "label": "Better stress management & mental wellbeing",
        "icon": "smile",
        "questionId": 'goals',
        "products": [
          {
            "inositol": 6000
          },
          {
            "ashwagandha-extract": 9999
          },
          {
            "5-htp": 9999
          },
          {
            "b12": 99999
          },
          {
            "coq10": 7500
          },
          {
            "folic-acid": 9999
          },
          {
            "hydrocurc-pepperine": 5000
          },
          {
            "lycopene": 5000
          },
          {
            "lactospore-probiotic": 5000
          },
          {
            "maca-powder": 2500
          },
          {
            "vegan-vitamin-d3": 5000
          },
          {
            "zinc": 99999
          },
          {
            "iodine": 5000,
          }
        ]
      },
      {
        "label": "Delay signs of aging",
        "icon": "aging",
        "questionId": 'goals',
        "products": [
          {
            "b12": 5000
          },
          {
            "coq10": 6000
          },
          {
            "folic-acid": 5000
          },
          {
            "ginger-extract": 6000
          },
          {
            "lycopene": 5000
          },
          {
            "milk-thistle-extract": 1000
          },
          {
            "resveratrol": 99999
          },
          {
            "selenium": 9999
          },
          {
            "silica": 99999
          },
          {
            "tart-cherry": 5000
          },
          {
            "vegan-vitamin-d3": 3500
          },
          {
            "vitamin-c": 9999
          },
          {
            "vitamin-e": 9999
          },
          {
            "zinc": 9999
          },
        ]
      },
      {
        "label": "Cardiovascular health",
        "icon": "heart",
        "questionId": 'goals',
        "products": [
          {
            "b12": 9999
          },
          {
            "careflow-mango-powder": 9999
          },
          {
            "coq10": 9999
          },
          {
            "cordyceps": 5000
          },
          {
            "folic-acid": 5500
          },
          {
            "ginger-extract": 4500
          },
          {
            "iron": 9999
          },
          {
            "k2-vital-delta": 9999
          },
          {
            "lycopene": 5000
          },
          {
            "nourished-greens": 5000
          },
          {
            "selenium": 2500
          },
          {
            "tart-cherry": 99999
          },
          {
            "vitamin-c": 9999
          }
        ]
      },
      {
        "label": "Improve performance, endurance & recovery",
        "icon": "shoe",
        "questionId": 'goals',
        "products": [
          {
            "ashwagandha-extract": 2500
          },
          {
            "b12": 9999
          },
          {
            "beetroot-powder": 9999
          },
          {
            "cordyceps": 9999
          },
          {
            "ginger-extract": 5000
          },
          {
            "ginseng": 9999
          },
          {
            "hydrocurc-pepperine": 9999
          },
          {
            "iron": 5000
          },
          {
            "maca-powder": 2500
          },
          {
            "tart-cherry": 99999
          },
        ]
      }
    ]
  };

  const dietsQuestion = {
    "question": "Which diet?",
    "subText": "Either by choice or becuase of allergies",
    "answers": [
      {
        "label": "Low carb",
        "questionId": "diet",
      },
      {
        "label": "Low fat",
        "questionId": "diet",
      },
      {
        "label": 'Vegetarian',
        "questionId": 'diet',
        "products": [
          {
            "b12": 99999
          },
          {
            "folic-acid": 99999
          },
          {
            "iron": 9998
          },
          {
            "vegan-vitamin-d3": 9999
          },
          {
            "zinc": 7000
          }
        ]
      },
      {
        "label": "Vegan",
        "questionId": "diet",
        "products": [
          {
            "b12": 99999
          },
          {
            "folic-acid": 99999
          },
          {
            "iron": 5000
          },
          {
            "lactospore-probiotic": 5000
          },
          {
            "vegan-vitamin-d3": 5000
          },
          {
            "zinc": 9000
          }
        ]
      },
      {
        "label": "Pescatarian",
        "questionId": "diet",
        "products": [
          {
            "iron": 3500
          },
          {
            "vegan-vitamin-d3": 2500
          },
          {
            "zinc": 5000
          }
        ]
      },
      {
        "label": "Dairy free",
        "questionId": "diet",
      },
      {
        "label": "Gluten free",
        "questionId": "diet",
      },
      {
        "label": "Nut free",
        "questionId": "diet",
      },
      {
        "label": "Reducetarian",
        "questionId": "diet",
        "products": [
          {
            "nourished-greens": 5000
          }
        ]
      }
    ]
  };

  const conditionsQuestion = {
    "question": "Does your child suffer from any of the below?",
    "answers": [
      {
        "label": "Long Covid",
        "questionId": "conditions",
        "products": [
          {
            "vitamin-c": 999999999999999
          },
          {
            "vegan-vitamin-d3": 999999999999999
          },
          {
            "zinc": 999999999999999
          },
          {
            "coq10": 999999999999999
          },
          {
            "lactospore-probiotic": 999999999999999
          },
          {
            "b12": 999999999999999
          },
          {
            "vitamin-a": 999999999999999
          }
        ]
      },
      {
        "label": "PCOS",
        "questionId": "conditions",
        "nonMale": true,
        "products": [
          {
            "inositol": 999999
          },
          {
            "coq10": 9999
          },
          {
            "vegan-vitamin-d3": 99999
          },
          {
            "zinc": 9999
          }
        ]
      },
      {
        "label": "Hypothyroidism",
        "questionId": "conditions",
        "products": [
          {
            "iodine": 1000000,
          }
        ]
      },
      {
        "label": "Hyperthyroidism",
        "questionId": "conditions",
      },
      {
        "label": "Endometriosis",
        "questionId": "conditions",
        "nonMale": true,
      },
      {
        "label": "Period concerns (PMS/PMDD)",
        "questionId": "conditions",
        "nonMale": true,
      },
      {
        "label": "ADHD",
        "questionId": "conditions",
        "products": [
          {
            "b12": 7500
          },
          {
            "coq10": 2500
          },
          {
            "vegan-vitamin-d3": 5000
          },
          {
            "vitamin-a": 2500
          },
          {
            "vitamin-c": 2500
          },
          {
            "vitamin-e": 2500
          },
          {
            "zinc": 2500
          }
        ]
      },
      {
        "label": "Asthma",
        "questionId": "conditions",
        "products": [
          {
            "b12": 5000
          },
          {
            "beta-glucan": 99999
          },
          {
            "folic-acid": 500
          },
          {
            "ginger-extract": 2500
          },
          {
            "hydrocurc-pepperine": 2500
          },
          {
            "selenium": 5000
          },
          {
            "vitamin-c": 5000
          }
        ]
      },
      {
        "label": "Coeliac disease",
        "questionId": "conditions",
        "products": [
          {
            "b12": 9999
          },
          {
            "hydrocurc-pepperine": 9999
          },
          {
            "lactospore-probiotic": 9999
          }
        ]
      },
      {
        "label": "Depression",
        "questionId": "conditions",
        "products": [
          {
            "ashwagandha-extract": 2500
          },
          {
            "5-htp": 9999
          },
          {
            "b12": 99999
          },
          {
            "hydrocurc-pepperine": 5000
          },
          {
            "vegan-vitamin-d3": 5000
          },
          {
            "vitamin-c": 2000
          },
          {
            "zinc": 2500
          },
          {
            "iodine": 5000,
          }
        ]
      },
      {
        "label": "Diabetes",
        "questionId": "conditions",
        "products": [
          {
            "iodine": 5000,
          }
        ]
      },
      {
        "label": "Frequent colds or flus",
        "questionId": "conditions",
        "products": [
          {
            "lactospore-probiotic": 9998
          },
          {
            "vegan-vitamin-d3": 2500
          },
          {
            "vitamin-a": 2500
          },
          {
            "vitamin-c": 2500
          },
          {
            "vitamin-e": 2500
          },
          {
            "zinc": 2500
          }
        ]
      },
      {
        "label": "Hayfever & seasonal allergies",
        "questionId": "conditions",
        "products": [
          {
            "beta-glucan": 9999
          },
          {
            "b12": 9999
          },
          {
            "ginger-extract": 2500
          },
          {
            "hydrocurc-pepperine": 2500
          },
          {
            "lactospore-probiotic": 5000
          },
          {
            "selenium": 5000
          },
          {
            "vegan-vitamin-d3": 2500
          },
          {
            "vitamin-a": 2500
          },
          {
            "vitamin-c": 2500
          },
          {
            "vitamin-e": 2500
          }
        ]
      },
      {
        "label": "High blood pressure",
        "questionId": "conditions",
        "products": [
          {
            "beetroot-powder": 9999
          },
          {
            "beta-glucan": 99999
          },
          {
            "careflow-mango-powder": 9999
          },
          {
            "coq10": 5000
          },
          {
            "k2-vital-delta": 9999
          },
          {
            "resveratrol": 2500
          },
          {
            "lycopene": 5000
          },
          {
            "selenium": 8000
          },
          {
            "tart-cherry": 5000
          },
          {
            "vegan-vitamin-d3": 5000
          },
          {
            "vitamin-c": 2500
          },
        ]
      },
      {
        "label": "High cholestrol",
        "questionId": "conditions",
        "products": [
          {
            "ashwagandha-extract": 9999
          },
          {
            "beetroot-powder": 9999
          },
          {
            "careflow-mango-powder": 5000
          },
          {
            "coq10": 5000
          },
          {
            "k2-vital-delta": 5000
          },
          {
            "lycopene": 5000
          },
          {
            "selenium": 7000
          },
        ]
      },
      {
        "label": "Hypertension",
        "questionId": "conditions",
        "products": [
          {
            "beta-glucan": 99999
          },
          {
            "careflow-mango-powder": 5000
          },
          {
            "coq10": 5000
          },
          {
            "k2-vital-delta": 9999
          },
          {
            "lycopene": 5000
          },
          {
            "resveratrol": 2500
          },
          {
            "selenium": 5000
          },
          {
            "silica": 1000
          },
          {
            "tart-cherry": 99999
          },
          {
            "vitamin-c": 2500
          },
        ]
      },
      {
        "label": "IBS",
        "questionId": "conditions",
        "products": [
          {
            "bpl1-ht": 5000
          },
          {
            "hydrocurc-pepperine": 9999
          },
          {
            "lactospore-probiotic": 9999
          }
        ]
      },
      {
        "label": "Low libido",
        "questionId": "conditions",
        "products": [
          {
            "ashwagandha-extract": 5000
          },
          {
            "5-htp": 9999
          },
          {
            "lycopene": 2500
          },
          {
            "maca-powder": 9999
          },
          {
            "vegan-vitamin-d3": 1500
          },
          {
            "vitamin-a": 1500
          },
          {
            "vitamin-c": 1500
          },
          {
            "vitamin-e": 1500
          },
          {
            "zinc": 1500
          }
        ]
      },
      {
        "label": "Menopause or pre-menopause",
        "questionId": "conditions",
        "nonMale": true,
        "products": [
          {
            "b12": 9999
          },
          {
            "folic-acid": 99999
          },
          {
            "ginseng": 99999
          },
          {
            "milk-thistle-extract": 99999
          },
        ]
      },
      {
        "label": "Migraines",
        "questionId": "conditions",
        "products": [
          {
            "5-htp": 5000
          },
          {
            "coq10": 99999
          },
        ]
      },
      {
        "label": "Obesity",
        "questionId": "conditions",
        "products": [
          {
            "bpl1-ht": 99999
          },
          {
            "5-htp": 5000
          },
          {
            "careflow-mango-powder": 9999
          },
          {
            "hydrocurc-pepperine": 2500
          },
          {
            "tart-cherry": 9999
          },
          {
            "white-kidney-extract": 9999
          },
          {
            "apple-cider-vinegar": 9999
          }
        ]
      },
      {
        "label": "Osteoporosis",
        "questionId": "conditions",
        "products": [
          {
            "k2-vital-delta": 1000
          },
          {
            "lycopene": 5000
          },
          {
            "milk-thistle-extract": 2500
          },
          {
            "silica": 9999
          },
          {
            "vegan-vitamin-d3": 5000
          },
          {
            "vitamin-a": 2500
          },
          {
            "vitamin-c": 2500
          },
          {
            "vitamin-e": 5000
          }
        ]
      },
      {
        "label": "No",
        "questionId": "conditions",
        "products": []
      },
    ]
  };

  const manageConditionsQuestion = {
    "question": "How do you manage your conditions",
    "answers": [
      {
        "label": "Lifestyle",
        "questionId": "manageConditions",
      },
      {
        "label": "Prescriptions",
        "questionId": "manageConditions",
      },
      {
        "label": "Supplements",
        "questionId": "manageConditions",
      },
      {
        "label": "Something else",
        "questionId": "manageConditions",
      },
    ]
  }

  const natalQuestion = {
    "answers": [
      {
        "label": "No",
        "value": "No",
        "questionId": "natal",
        "products": [
          {
            "beta-glucan": 103
          },
          {
            "lactospore-probiotic": 102
          }
        ]
      },
      {
        "label": "I'm pregnant",
        "value": "pregnant",
        "questionId": "natal",
        "products": [
          {
            "beta-glucan": 500
          },
          {
            "folic-acid": 99999
          },
          {
            "ginger-extract": 99999
          },
          {
            "iron": 9999
          },
          {
            "k2-vital-delta": 9999
          },
          {
            "milk-thistle-extract": 9999
          },
          {
            "lactospore-probiotic": 9999
          },
          {
            "vegan-vitamin-d3": 9999
          },
          {
            "iodine": 9999,
          }
        ]
      },
      {
        "label": "I'm breastfeeding",
        "value": "breastfeeding",
        "questionId": "natal",
        "products": [
          {
            "folic-acid": 99999
          },
          {
            "ginger-extract": 99999
          },
          {
            "iron": 9999
          },
          {
            "k2-vital-delta": 9999
          },
          {
            "milk-thistle-extract": 9999
          },
          {
            "lactospore-probiotic": 9999
          },
          {
            "vegan-vitamin-d3": 9999
          },
        ]
      },
      {
        "label": "I'm postnatal",
        "value": "postnatal",
        "questionId": "natal",
        "products": [
          {
            "beta-glucan": 50
          },
          {
            "folic-acid": 99999
          },
          {
            "ginger-extract": 99999
          },
          {
            "iron": 9999
          },
          {
            "k2-vital-delta": 9999
          },
          {
            "milk-thistle-extract": 9999
          },
          {
            "lactospore-probiotic": 9999
          },
          {
            "vegan-vitamin-d3": 9999
          },
        ]
      },
      {
        "label": "I'm trying to conceive",
        "value": "trying to conceive",
        "questionId": "natal",
        "products": [
          {
            "iodine": 9999
          },
          {
            "ashwagandha-extract": 9999
          },
          {
            "beta-glucan": 500
          },
          {
            "folic-acid": 99999
          },
          {
            "ginger-extract": 99999
          },
          {
            "iron": 9999
          },
          {
            "k2-vital-delta": 9999
          },
          {
            "milk-thistle-extract": 9999
          },
          {
            "lactospore-probiotic": 9999
          },
          {
            "vegan-vitamin-d3": 9999
          },
        ]
      },
    ]
  };

  const renderGenderAnswers = genderAnswers.map((answer) => {
    return (
      <button
        key={answer.value}
        className={`answer-button ${gender === answer.value ? 'answer-button--active' : ''}`}
        name={answer.name}
        onClick={() => updateGender(answer.value)}
      >
        {answer.label}
      </button>
    );
  });

  const renderRaceAnswers = raceAnswers.map((answer) => {
    return (
      <button
        key={answer.value}
        className={`answer-button ${race === answer.value ? 'answer-button--active' : ''}`}
        name={answer.name}
        onClick={() => updateRace(answer.value)}
      >
        {answer.label}
      </button>
    );
  });

  const updateGender = (answer) => {
    setGender(answer);
    updateQuestionUrl('gender');
  }

  const updateRace = (answer) => {
    setRace(answer);
    updateQuestionUrl('race');
  }

  const onChangeNumber = (e) => {
    const re = /^[0-9\b]+$/;
    // make sure that only numbers can be input into the age field
    if (e.target.value === '' || re.test(e.target.value)) {
      setAge(e.target.value);
    }
    updateQuestionUrl('age');
  };

  const checkAge = () => {
    if (age && age < 17) {
      setSuitableAge(false);
    } else {
      setSuitableAge(true);
    }
  };

  const ageWarningMessage = () => {
    if (!suitableAge) {
      return (
        <>
          <p>We recommend the Kids Quiz for people under the age of 17, please click the button below to proceed</p>
          <a href="/pages/kids-quiz" className="next-page">Kids Quiz</a>
        </>
      );
    } else {
      return;
    }
  };

  const renderGoalAnswers = goalsQuestion.answers.map((answer, index) => {
    const disabled = activeGoalsAnswer.indexOf(answer.label) == -1 && activeGoalsAnswer.length > 1;

    if (answer.nonMale && gender === 'male') {
      return;
    } else {
      return (
        <div
          key={index}
          className={`answer-button answer-button__icon ${activeGoalsAnswer.indexOf(answer.label) !== -1 ? 'answer-button--active' : activeGoalsAnswer.length > 1 ? 'answer-button--disabled' : ''}`}
          onClick={e => disabled ? '' : logAnswers(answer, answer.label, answer.questionId)}
          disabled={disabled}
        >
          {answer.icon === 'aging' ? <AntiAging /> : ''}
          {answer.icon === 'weight' ? <LoseWeight /> : ''}
          {answer.icon === 'energy' ? <Energy /> : ''}
          {answer.icon === 'immunity' ? <Immunity /> : ''}
          {answer.icon === 'focus' ? <Focus /> : ''}
          {answer.icon === 'face' ? <Face /> : ''}
          {answer.icon === 'eye' ? <Eye /> : ''}
          {answer.icon === 'smile' ? <Smile /> : ''}
          {answer.icon === 'gut' ? <Gut /> : ''}
          {answer.icon === 'fruit' ? <Fruit /> : ''}
          {answer.icon === 'shoe' ? <Shoe /> : ''}
          {answer.icon === 'heart' ? <HeartHealth /> : ''}
          {answer.icon === 'periodHealth' ? <PeriodHealth /> : ''}
          {answer.icon === 'excessHair' ? <ExcessHair /> : ''}
          {answer.icon === 'improveHair' ? <ImproveHair /> : ''}
          {answer.icon === 'hotFlash' ? <HotFlash /> : ''}
          {answer.icon === 'sexualHealth' ? <SexualHealth /> : ''}
          {answer.icon === 'sleep' ? <Sleep /> : ''}
          {answer.icon === 'bone' ? <Bone /> : ''}

          {answer.label}
        </div>
      );
    }
  });

  const logAnswers = (answer, index, questionId) => {
    updateQuestionUrl('goals');
    // If answer is already selected...
    if (activeGoalsAnswer.indexOf(index) !== -1) {
      const newActiveGoalsAnswer = activeGoalsAnswer.filter(item => item !== index);
      setActiveGoalsAnswer(newActiveGoalsAnswer);
      let weightingsToKeep = [];
      weightingAnswers[questionId].forEach(element => {
        if (element.label !== index) {
          weightingsToKeep.push(element);
        }
      });
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: weightingsToKeep
      }));
    } else {
      setActiveGoalsAnswer(prevAnswers => ([
        ...prevAnswers,
        index
      ]));
      if (answer.products !== undefined) {
        if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
          const updatedAnswer = [...weightingAnswers[questionId], answer];
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: updatedAnswer
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: [answer]
          }));
        }
      }
    }
  };

  const logExerciseAnswers = (answer, index, questionId) => {
    updateQuestionUrl('exercise');
    // If answer is already selected...
    if (exerciseAnswersIndex.indexOf(index) !== -1) {
      // remove it from the index tracker
      const newExerciseAnswersIndex = exerciseAnswersIndex.filter(item => item !== index);
      setExerciseAnswersIndex(newExerciseAnswersIndex);
      let weightingsToKeep = [];
      weightingAnswers[questionId].forEach(element => {
        if (element.label !== index) {
          weightingsToKeep.push(element);
        }
      });
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: weightingsToKeep
      }));
    } else if (index === 'None') {
      setExerciseAnswersIndex([index]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: {}
      }));
    } else {
      setExerciseAnswersIndex(prevAnswers => {
        let newAnswers = prevAnswers;
        if (prevAnswers.indexOf('None') !== -1) {
          newAnswers = newAnswers.filter(item => item !== 'None');
        }
        return ([...newAnswers, index]);
      });
      if (answer.products !== undefined) {
        if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
          const updatedAnswer = [...weightingAnswers[questionId], answer];
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: updatedAnswer
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: [answer]
          }));
        }
      }
    }
  };

  const logTravelAnswers = (answer, index, questionId) => {
    updateQuestionUrl('travel');
    if (travelAnswersIndex === index) {
      setTravelAnswersIndex([]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: {}
      }));
    } else {
      setTravelAnswersIndex(index);
      if (answer.products !== undefined) {
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          [questionId]: answer
        }));
      } else {
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          [questionId]: {}
        }));
      }
    }
  };

  const logAlcoholAnswers = (answer, index, questionId) => {
    updateQuestionUrl('alcohol');
    if (alcoholAnswersIndex === index) {
      setAlcoholAnswersIndex([]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: {}
      }));
    } else {
      setAlcoholAnswersIndex(index);
      if (answer.products !== undefined) {
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          [questionId]: answer
        }));
      } else {
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          [questionId]: {}
        }));
      }
    }
  };


  const logMultipleAnswers = (answer, index, questionId) => {
    updateQuestionUrl('dietSelection');
    // If answer is already selected...
    if (dietAnswersIndex.indexOf(index) !== -1) {
      // remove it from the index tracker
      const newDietAnswersIndex = dietAnswersIndex.filter(item => item !== index);
      setDietAnswersIndex(newDietAnswersIndex);
      //remove the weighting
      let weightingsToKeep = [];
      weightingAnswers[questionId].forEach(element => {
        if (element.label !== index) {
          weightingsToKeep.push(element);
        }
      });
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: weightingsToKeep
      }));
    } else {
      setDietAnswersIndex(prevAnswers => ([
        ...prevAnswers,
        index
      ]));
      if (answer.products !== undefined) {
        if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
          const updatedAnswer = [...weightingAnswers[questionId], answer];
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: updatedAnswer
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: [answer]
          }));
        }
      }
    }
  };

  const logMultipleConditionsAnswers = (answer, index, questionId) => {
    updateQuestionUrl('conditions');
    // If answer is already selected...
    if (conditionsAnswerIndex.indexOf(index) !== -1) {
      // remove it from the index tracker
      const newConditionsAnswerIndex = conditionsAnswerIndex.filter(item => item !== index);
      setConditionsAnswerIndex(newConditionsAnswerIndex);
      //remove the weighting
      let weightingsToKeep = [];
      weightingAnswers[questionId].forEach(element => {
        if (element.label !== index) {
          weightingsToKeep.push(element);
        }
      });
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: weightingsToKeep
      }));
    } else if (index === 'No') {
      setConditionsAnswerIndex([index]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: {}
      }));
    } else {
      setConditionsAnswerIndex(prevAnswers => {
        let newAnswers = prevAnswers;
        if (prevAnswers.indexOf('No') !== -1) {
          newAnswers = newAnswers.filter(item => item !== 'No');
        }
        return ([...newAnswers, index]);
      });
      if (answer.products !== undefined) {
        if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
          const updatedAnswer = [...weightingAnswers[questionId], answer];
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: updatedAnswer
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: [answer]
          }));
        }
      }
    }
  };

  const logManageConditions = (answer, index, questionId) => {
    updateQuestionUrl('manageConditions');
    // If answer is already selected...
    if (manageConditionsAnswerIndex.indexOf(index) !== -1) {
      // remove it from the index tracker
      const newManageConditionsAnswerIndex = manageConditionsAnswerIndex.filter(item => item !== index);
      setManageConditionsAnswerIndex(newManageConditionsAnswerIndex);
    } else {
      setManageConditionsAnswerIndex(prevAnswers => {
        let newAnswers = prevAnswers;
        return ([...newAnswers, index]);
      });
    }
  };

  const logNatalAnswers = (answer, index, questionId) => {
    updateQuestionUrl('natal');
    // If answer is already selected...
    if (natalAnswerIndex.indexOf(index) !== -1) {
      // remove it from the index tracker
      const newNatalAnswerIndex = natalAnswerIndex.filter(item => item !== index);
      setNatalAnswerIndex(newNatalAnswerIndex);
      //remove the weighting
      let weightingsToKeep = [];
      weightingAnswers[questionId].forEach(element => {
        if (element.label !== index) {
          weightingsToKeep.push(element);
        }
      });
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: weightingsToKeep
      }));
    } else if (index === 'No') {
      setNatalAnswerIndex([index]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: {}
      }));
    } else {
      setNatalAnswerIndex(prevAnswers => {
        let newAnswers = prevAnswers;

        if (index === `I'm trying to conceive`) {
          if (prevAnswers.indexOf(`I'm pregnant`) !== -1) {
            newAnswers = newAnswers.filter(item => item !== `I'm pregnant`);
          }
        } else if (index === `I'm pregnant`) {
          if (prevAnswers.indexOf(`I'm trying to conceive`) !== -1) {
            newAnswers = newAnswers.filter(item => item !== `I'm trying to conceive`);
          }
        }

        if (prevAnswers.indexOf('No') !== -1) {
          newAnswers = newAnswers.filter(item => item !== 'No');
        }

        return ([...newAnswers, index]);
      });
      if (answer.products !== undefined) {
        if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
          let updatedAnswer = [...weightingAnswers[questionId], answer];

          if (index === `I'm trying to conceive`) {
            updatedAnswer = updatedAnswer.filter(option => option.value !== 'pregnant');
          } else if (index === `I'm pregnant`) {
            updatedAnswer = updatedAnswer.filter(option => option.value !== 'trying to conceive');
          }

          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: updatedAnswer
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: [answer]
          }));
        }
      }
    }
  };

  const logHungryAnswer = (event) => {
    updateQuestionUrl('hungry');
    const radioValue = event.target.value;

    if (radioValue === 'yes') {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "hungry": {
          "products": [
            {
              "ashwagandha-extract": 5000
            },
            {
              "b12": 99999
            },
            {
              "beetroot-powder": 7500
            },
            {
              "maca-powder": 5000
            },
            {
              "white-kidney-extract": 2000
            },
            {
              "iodine": 5000,
            }
          ]
        }
      }))
      setHungryBetweenMeals('yes');
    } else {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "hungry": {}
      }));
      setHungryBetweenMeals('no');
    }
  };

  const logGlassesAnswer = (event) => {
    updateQuestionUrl('glasses');
    const radioValue = event.target.value;

    if (radioValue === 'yes') {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "glasses": {
          "products": [
            {
              "lycopene": 9999
            },
            {
              "vegan-vitamin-d3": 5000
            },
            {
              "vitamin-a": 9999
            },
            {
              "vitamin-c": 5000
            },
            {
              "vitamin-e": 7000
            },
          ]
        }
      }))
      setGlassesAnswer(radioValue);
    } else {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "glasses": {}
      }));
      setGlassesAnswer(radioValue);
    }
  };

  const logIodineAnswer = (event) => {
    const radioValue = event.target.value;
    setIodineAnswer(radioValue);
    updateQuestionUrl('iodine');
  }

  const logMedicationAnswer = (event) => {
    const radioValue = event.target.value;
    setMedicationAnswer(radioValue);
    updateQuestionUrl('medication');
  }

  const onSpecificDietClick = (event) => {
    updateQuestionUrl('specificDiet');
    if (event.target.value === 'no') {
      setDietAnswersIndex([]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        'diet': []
      }));
      setSpecificDiet('no');
    } else {
      setSpecificDiet('yes');
    }
  }

  const renderExerciseAnswers = exerciseQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${exerciseAnswersIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logExerciseAnswers(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const renderTravelAnswers = travelQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${travelAnswersIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logTravelAnswers(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const renderDietAnswers = dietsQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${dietAnswersIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logMultipleAnswers(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const renderAlcoholAnswers = alcoholQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${alcoholAnswersIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logAlcoholAnswers(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const currentVitamins = (e) => {
    updateQuestionUrl('vitamins');
    setVitaminsAnswer(e.target.value);
  }

  const renderConditionsAnswers = conditionsQuestion.answers.map((answer) => {
    if (answer.nonMale && gender === 'male') {
      return;
    } else {
      return (
        <div
          key={answer.label}
          className={`answer-button ${conditionsAnswerIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
          onClick={e => logMultipleConditionsAnswers(answer, answer.label, answer.questionId)}
        >
          {answer.label}
        </div>
      );
    }
  });

  const renderManageConditionsAnswers = manageConditionsQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${manageConditionsAnswerIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logManageConditions(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const renderNatalAnswers = natalQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${natalAnswerIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logNatalAnswers(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const handleFoodRadios = (e) => {
    updateQuestionUrl('foodRadio');
    switch (e.target.id) {
      case 'processedFoodRarely':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {}
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'processedFood12':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {}
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'processedFood34':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {
            "products": [
              {
                "nourished-greens": 2000
              },
              {
                "lactospore-probiotic": 2500
              },
            ]
          }
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'processedFood5':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {
            "products": [
              {
                "bpl1-ht": 9999
              },
              {
                "hydrocurc-pepperine": 2500
              },
              {
                "nourished-greens": 9999
              },
              {
                "lactospore-probiotic": 5000
              },
              {
                "white-kidney-extract": 7000
              },
              {
                "apple-cider-vinegar": 9999
              }
            ]
          }
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'fruitVegRarely':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {
            "products": [
              {
                "bpl1-ht": 9999
              },
              {
                'beetroot-powder': 2500
              },
              {
                'cordyceps': 5000
              },
              {
                "lycopene": 5000
              },
              {
                "nourished-greens": 9999
              },
              {
                "tart-cherry": 5000
              },
              {
                "apple-cider-vinegar": 5000
              }
            ]
          }
        }));
        setFruitVegAnswer(e.target.id);
        break;
      case 'fruitVeg12':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {
            "products": [
              {
                'cordyceps': 5000
              },
              {
                "lycopene": 2500
              },
              {
                "nourished-greens": 2500
              },
              {
                "tart-cherry": 2500
              },
              {
                "apple-cider-vinegar": 2500
              }
            ]
          }
        }));
        setFruitVegAnswer(e.target.id);
        break;
      case 'fruitVeg34':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {
            "products": [
              {
                'cordyceps': 2500
              },
            ]
          }
        }));
        setFruitVegAnswer(e.target.id);
        break;
      case 'fruitVeg5':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {}
        }));
        setFruitVegAnswer(e.target.id);
        break;
      default:
        break;
    }
  }

  const handleSlider = (value, sliderId) => {
    const sliderValue = value;

    switch (sliderId) {
      case 'energy':
        updateQuestionUrl('energy');
        setEnergySliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "energySlider": {
              "products": [
                {
                  "iodine": 9999
                },
                {
                  "5-htp": 50
                },
                {
                  "b12": 99999
                },
                {
                  "beetroot-powder": 5000
                },
                {
                  "coq10": 9999
                },
                {
                  "ginseng": 5000
                },
                {
                  "iron": 99999
                },
                {
                  "maca-powder": 5000
                },
                {
                  "tart-cherry": 99999
                }
              ]
            }
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "energySlider": {
              "products": [
                {
                  "iodine": 5000
                },
                {
                  "5-htp": 250
                },
                {
                  "b12": 75000
                },
                {
                  "beetroot-powder": 2500
                },
                {
                  "coq10": 5000
                },
                {
                  "ginseng": 2500
                },
                {
                  "iron": 5000
                },
                {
                  "maca-powder": 2500
                },
                {
                  "tart-cherry": 50000
                }
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "energySlider": {}
          }));
        }
        break;

      case 'activity':
        updateQuestionUrl('activity');
        setActivitySliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "activitySlider": {
              "products": [
                {
                  "bpl1-ht": 9999
                },
              ]
            }
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "activitySlider": {
              "products": [
                {
                  "b12": 5000
                },
                {
                  "cordyceps": 3500
                },
                {
                  "k2-vital-delta": 500
                },
                {
                  "tart-cherry": 5000
                }
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "activitySlider": {
              "products": [
                {
                  'b12': 7000
                },
                {
                  "beetroot-powder": 9000
                },
                {
                  "cordyceps": 7500
                },
                {
                  "ginseng": 2500
                },
                {
                  "hydrocurc-pepperine": 5000
                },
                {
                  "k2-vital-delta": 1000
                },
                {
                  "maca-powder": 5000
                },
                {
                  "silica": 9998
                },
                {
                  "tart-cherry": 99999
                }
              ]
            }
          }));
        }
        break;

      case 'sleep':
        updateQuestionUrl('sleep');
        setSleepSliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "sleepSlider": {
              "products": [
                {
                  "5-htp": 9999
                },
                {
                  "b12": 7500
                },
                {
                  "tart-cherry": 99999
                },
              ]
            }
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "sleepSlider": {
              "products": [
                {
                  "ashwagandha-extract": 7500
                },
                {
                  "5-htp": 5000
                },
                {
                  "b12": 5000
                },
                {
                  "tart-cherry": 5000
                },
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "sleepSlider": {
              "products": [
                {
                  "ashwagandha-extract": 9999
                }
              ]
            }
          }));
        }
        break;

      case 'screen':
        updateQuestionUrl('screen');
        setScreenSliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "screenSlider": {}
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "screenSlider": {
              "products": [
                {
                  "b12": 5000
                },
                {
                  "coq10": 2500
                },
                {
                  "folic-acid": 2500
                },
                {
                  "lycopene": 5000
                },
                {
                  "selenium": 5000
                },
                {
                  "vitamin-a": 99999
                },
                {
                  "vitamin-c": 5000
                },
                {
                  "vitamin-e": 2500
                },
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "screenSlider": {
              "products": [
                {
                  "b12": 99999
                },
                {
                  "coq10": 5000
                },
                {
                  "folic-acid": 5000
                },
                {
                  "lycopene": 9000
                },
                {
                  "selenium": 9999
                },
                {
                  "vitamin-a": 99999
                },
                {
                  "vitamin-c": 9999
                },
                {
                  "vitamin-e": 5000
                },
              ]
            }
          }));
        }
        break;

      case 'conditionsSlider':
        updateQuestionUrl('conditionsSlider');
        setConditionsEffectSlider(sliderValue);
        break;

      default:
        break;
    }
  }

  const selectFlavour = (e) => {
    updateQuestionUrl('flavour');
    setFlavour(e.target.value);
  }

  const selectCoating = (e) => {
    updateQuestionUrl('coating');
    setCoating(e.target.value);
  }

  const calculateWeights = async () => {
    let weights = {};

    const addToWeighting = (product, weighting) => {
      weights[product]
        ? weights[product] += weighting
        : weights[product] = weighting;
    }

    (function retrieveWeights(obj) {
      for (const [key, value] of Object.entries(obj)) {
        switch (key) {
          case 'ashwagandha-extract':
            addToWeighting(key, value);
            break;
          case 'b12':
            addToWeighting(key, value);
            break;
          case 'beetroot-powder':
            addToWeighting(key, value);
            break;

          case 'beta-glucan':
            addToWeighting(key, value);
            break;

          case 'careflow-mango-powder':
            addToWeighting(key, value);
            break;

          case 'coq10':
            addToWeighting(key, value);
            break;

          case 'cordyceps':
            addToWeighting(key, value);
            break;

          case 'folic-acid':
            addToWeighting(key, value);
            break;

          case 'ginger-extract':
            addToWeighting(key, value);
            break;

          case 'ginseng':
            addToWeighting(key, value);
            break;

          case 'hydrocurc-pepperine':
            addToWeighting(key, value);
            break;

          case 'iron':
            addToWeighting(key, value);
            break;

          case 'k2-vital-delta':
            addToWeighting(key, value);
            break;

          case 'lutemax':
            addToWeighting(key, value);
            break;

          case 'lycopene':
            addToWeighting(key, value);
            break;

          case 'maca-powder':
            addToWeighting(key, value);
            break;

          case 'milk-thistle-extract':
            addToWeighting(key, value);
            break;

          case 'nourished-greens':
            addToWeighting(key, value);
            break;

          case 'lactospore-probiotic':
            addToWeighting(key, value);
            break;

          case 'resveratrol':
            addToWeighting(key, value);
            break;

          case 'scutellup':
            addToWeighting(key, value);
            break;

          case 'selenium':
            addToWeighting(key, value);
            break;

          case 'silica':
            addToWeighting(key, value);
            break;

          case 'tart-cherry':
            addToWeighting(key, value);
            break;

          case 'vegan-vitamin-d3':
            addToWeighting(key, value);
            break;

          case 'vitamin-a':
            addToWeighting(key, value);
            break;

          case 'vitamin-c':
            addToWeighting(key, value);
            break;

          case 'vitamin-e':
            addToWeighting(key, value);
            break;

          case 'white-kidney-extract':
            addToWeighting(key, value);
            break;

          case 'zinc':
            addToWeighting(key, value);
            break;

          case 'apple-cider-vinegar':
            addToWeighting(key, value);
            break;

          case 'bpl1-ht':
            addToWeighting(key, value);
            break;

          case '5-htp':
            addToWeighting(key, value);
            break;

          case 'iodine':
            addToWeighting(key, value);
            break;

          case 'inositol':
            addToWeighting(key, value);
            break;

          default:
            break;
        }

        if (typeof value === 'object') {
          retrieveWeights(value);
        }
      }
    }(weightingAnswers));

    function findTopSeven(obj) {
      return Object.keys(obj).sort((a, b) => { return obj[b] - obj[a] }).slice(0, 7);
    }

    // If there are any pregnancy concerns,
    // remove Vitmin A and 5-HTP
    if (natalAnswerIndex.length !== 0 && natalAnswerIndex[0] !== 'No') {
      delete weights['vitamin-a'];
      delete weights['5-htp'];
    }

    // If the user takes any medication,
    // remove 5-HTP
    if (medicationAnswer === 'yes') {
      delete weights['5-htp'];
    }

    if (iodineAnswer === 'yes' || conditionsAnswerIndex.includes('Hyperthyroidism')) {
      delete weights['iodine'];
    }

    delete weights['k2-vital-delta']; // while stock is low

    // Get the top 7 weightings
    let suggestedInclusions = findTopSeven(weights);

    // If inositiol is in the top 7 weightins, make it a double layer
    if (suggestedInclusions.includes('inositol')) {
      suggestedInclusions.splice(suggestedInclusions.indexOf('inositol'), 0, 'inositol');
      suggestedInclusions = suggestedInclusions.slice(0, 7);
    }

    // If the user has selected any vitamins that they want in their stack,
    // give those vitimins priority over the weightings
    if (selectedVitamins.length > 0) {
      let inositiolCount = 0;
      let vitaminDCount = 0;
      let sortedInclusions = [];

      selectedVitamins.forEach(vitamin => {
        if (vitamin.value.includes('inositol')) {
          inositiolCount++;
          return;
        }

        if (vitamin.value.includes('vitamin-d')) {
          vitaminDCount++;
          return;
        }

        // check that the vitamin isn't already present in the weightings to ensure no double up
        if (suggestedInclusions.includes(vitamin.value)) {
          // if the vitamin is already present, remove it so that it can be added to the beginning of the list
          suggestedInclusions.splice(suggestedInclusions.indexOf(vitamin.value), 1);
        }
        suggestedInclusions.unshift(vitamin.value);
      });

      // Check if inositol is present in the array
      while (suggestedInclusions.some(inclusion => inclusion.startsWith('inositol')) && inositiolCount > 0) {
        // Move the first occurrence of a string that starts with 'inositol' to the beginning of the array
        sortedInclusions.unshift(suggestedInclusions.splice(suggestedInclusions.findIndex(inclusion => inclusion.startsWith('inositol')), 1)[0]);
        inositiolCount--;
      }

      // Check if vegan-vitamin-d3 is present in the array
      while (suggestedInclusions.some(inclusion => inclusion.startsWith('vegan-vitamin-d3')) && vitaminDCount > 0) {
        // Move the first occurrence of a string that starts with 'vegan-vitamin-d3' to the beginning of the array
        sortedInclusions.unshift(suggestedInclusions.splice(suggestedInclusions.findIndex(inclusion => inclusion.startsWith('vegan-vitamin-d3')), 1)[0]);
        vitaminDCount--;
      }

      while (inositiolCount > 0) {
        sortedInclusions.unshift('inositol');
        inositiolCount--;
      }

      while (vitaminDCount > 0) {
        sortedInclusions.unshift('vegan-vitamin-d3');
        vitaminDCount--;
      }

      suggestedInclusions = sortedInclusions.concat(suggestedInclusions);

      // Trim down to 7 inclusions
      suggestedInclusions = suggestedInclusions.slice(0, 7);
    }


    let selectedDiets = '';
    if (dietAnswersIndex.length > 0) {
      selectedDiets = dietAnswersIndex.join(', ');
    }


    let natalAnswers = '';
    if (natalAnswerIndex.length > 0) {
      natalAnswers = natalAnswerIndex.join(', ');
    }

    let payload = {
      firstName,
      priority: activeGoalsAnswer,
      age,
      gender,
      selectedDiets,
      natalAnswers,
      flavour,
      coating,
      handles: suggestedInclusions,
      quizID: quizID,
      timestamp: Date.now(),
    }

    // console.log(JSON.stringify(payload));
    // console.log(payload);

    if (email !== '' && consent) {
      await klaviyoData(suggestedInclusions);
    }

    let selelctedVitaminsArray = [];
    let userSelectedVitamins = '';
    if (selectedVitamins.length > 0) {
      selectedVitamins.forEach(vitamin => {
        selelctedVitaminsArray.unshift(vitamin.value);
      });
      userSelectedVitamins = selelctedVitaminsArray.join(', ');
    }

    // Record quiz amount in session and local storage
    let quizSession;
    let quizLocal;

    let currentSessionCount = sessionStorage.getItem('quizSession');
    let currentLocalCount = localStorage.getItem('quizLocal');

    if (currentSessionCount) {
      quizSession = parseInt(currentSessionCount) + 1;
      sessionStorage.setItem('quizSession', quizSession);
    } else {
      quizSession = 1;
      sessionStorage.setItem('quizSession', quizSession);
    }

    if (currentLocalCount) {
      quizLocal = parseInt(currentLocalCount) + 1;
      localStorage.setItem('quizLocal', quizLocal);
    } else {
      quizLocal = 1;
      localStorage.setItem('quizLocal', quizLocal);
    }

    const dataToSend = {
      "1": `${gender}`,
      "2": `${age}`,
      "3": `${race}`,
      "4": `${energySliderValue}`,
      "5": `${activitySliderValue}`,
      "6": `${sleepSliderValue}`,
      "7": `${screenSliderValue}`,
      "8": `${exerciseAnswersIndex}`,
      "9": `${travelAnswersIndex}`,
      "10": `${specificDiet}`,
      "11": `${dietAnswersIndex}`,
      "12": `${hungryBetweenMeals}`,
      "13": `${processedFoodAnswer}`,
      "14": `${fruitVegAnswer}`,
      "15": `${alcoholAnswersIndex}`,
      "16": `${vitaminsAnswer}`,
      "17": `${glassesAnswer}`,
      "18": `${conditionsAnswerIndex}`,
      "19": `${conditionsEffectSlider}`,
      "20": `${manageConditionsAnswerIndex}`,
      "21": `${medicationAnswer}`,
      "22": `${natalAnswerIndex}`,
      "23": `${selelctedVitaminsArray}`,
      "24": `${activeGoalsAnswer}`,
      "25": `${flavour}`,
      "26": `${coating}`,
      "27": `${consent}`,
      "28": `${suggestedInclusions[0]}`,
      "29": `${suggestedInclusions[1]}`,
      "30": `${suggestedInclusions[2]}`,
      "31": `${suggestedInclusions[3]}`,
      "32": `${suggestedInclusions[4]}`,
      "33": `${suggestedInclusions[5]}`,
      "34": `${suggestedInclusions[6]}`,
      "35": `${new Date().toLocaleString('en-GB')}`,
      "36": `${Date.now()}`,
      "37": `${quizSession}`,
      "38": `${quizLocal}`,
      "39": `${quizID}`,
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    // Send data to google sheets
    // avoid test data
    if (firstName.toLowerCase() !== 'test' || firstName !== '') {
      fetch(`https://script.google.com/macros/s/AKfycbwtEijjmga7mUOr1DLo0LuQZ7ESxQF8i2o51LY5LCFw26JFoQ-gfm6fpoZKgMycd8zmjw/exec`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(dataToSend),
        signal: controller.signal
      })
        .then(function (res) {
          window.localStorage.setItem('nourished-core-quiz-results', JSON.stringify(payload));
          window.location = '/pages/quiz-results';
        })
        .catch(function (err) {
          window.localStorage.setItem('nourished-core-quiz-results', JSON.stringify(payload));
          window.location = '/pages/quiz-results';
        });
    } else {
      window.localStorage.setItem('nourished-core-quiz-results', JSON.stringify(payload));
      window.location = '/pages/quiz-results';
    }
  }

  const klaviyoData = (resultsInclusions) => {
    return new Promise((resolve, reject) => {
      let handlesString = 'Error in handles';
      let exercise = 'non selected';
      let selectedDiets = 'non selected';
      let healthConditions = 'non selected';
      let manageHealthConditions = 'non selected';
      let natal = 'not specificed';
      let userSelectedVitamins = 'none';
      let goals = 'non selected';
      let prioritiesNumbers = [];
      let dietsNumbers = [];
      let handlesNumbers = [];
      let resultsLink = '?';

      if (resultsInclusions.length > 0) {
        handlesString = resultsInclusions.join(', ');

        resultsInclusions.forEach(handle => {
          switch (handle) {
            case '5-htp':
              handlesNumbers.push('1');
              break;
            case 'apple-cider-vinegar':
              handlesNumbers.push('2');
              break;
            case 'ashwagandha-extract':
              handlesNumbers.push('3');
              break;
            case 'beetroot-powder':
              handlesNumbers.push('4');
              break;
            case 'beta-glucan':
              handlesNumbers.push('5');
              break;
            case 'careflow-mango-powder':
              handlesNumbers.push('6');
              break;
            case 'coq10':
              handlesNumbers.push('7');
              break;
            case 'cordyceps':
              handlesNumbers.push('8');
              break;
            case 'folic-acid':
              handlesNumbers.push('9');
              break;
            case 'ginger-extract':
              handlesNumbers.push('10');
              break;
            case 'ginseng':
              handlesNumbers.push('11');
              break;
            case 'bpl1-ht':
              handlesNumbers.push('12');
              break;
            case 'hydrocurc-pepperine':
              handlesNumbers.push('13');
              break;
            case 'iron':
              handlesNumbers.push('14');
              break;
            case 'k2-vital-delta':
              handlesNumbers.push('15');
              break;
            case 'lactospore-probiotic':
              handlesNumbers.push('16');
              break;
            case 'lycopene':
              handlesNumbers.push('17');
              break;
            case 'maca-powder':
              handlesNumbers.push('18');
              break;
            case 'milk-thistle-extract':
              handlesNumbers.push('19');
              break;
            case 'nourished-greens':
              handlesNumbers.push('20');
              break;
            case 'resveratrol':
              handlesNumbers.push('21');
              break;
            case 'scutellup':
              handlesNumbers.push('22');
              break;
            case 'selenium':
              handlesNumbers.push('23');
              break;
            case 'silica':
              handlesNumbers.push('24');
              break;
            case 'tart-cherry':
              handlesNumbers.push('25');
              break;
            case 'vegan-vitamin-d3':
              handlesNumbers.push('26');
              break;
            case 'vitamin-a':
              handlesNumbers.push('27');
              break;
            case 'b12':
              handlesNumbers.push('28');
              break;
            case 'vitamin-c':
              handlesNumbers.push('29');
              break;
            case 'vitamin-e':
              handlesNumbers.push('30');
              break;
            case 'white-kidney-extract':
              handlesNumbers.push('31');
              break;
            case 'zinc':
              handlesNumbers.push('32');
              break;
            case 'inositol':
              handlesNumbers.push('33');
              break;
            case 'lutemax':
              handlesNumbers.push('35');
              break;
            case 'iodine':
              handlesNumbers.push('36');
              break;
            default:
              break;
          }
        });
      }


      if (exerciseAnswersIndex.length > 0) {
        exercise = exerciseAnswersIndex.join(', ');
      }

      if (dietAnswersIndex.length > 0) {
        selectedDiets = dietAnswersIndex.join(', ');

        dietAnswersIndex.forEach(diet => {
          switch (diet) {
            case 'Vegetarian':
              dietsNumbers.push('1');
              break;
            case 'Vegan':
              dietsNumbers.push('2');
              break;
            case 'Pescatarian':
              dietsNumbers.push('3');
              break;
            case 'Dairy free':
              dietsNumbers.push('4');
              break;
            case 'Gluten free':
              dietsNumbers.push('5');
              break;
            case 'Nut free':
              dietsNumbers.push('6');
              break;
            case 'Reducetarian':
              dietsNumbers.push('7');
              break;
            default:
              break;
          }
        })
      }

      let natalAnswers = [];
      // loop through natal answers index
      // for each value, add a corresponding value to natalAnswers
      // if the value is 'No', add '0'
      // if the value contains 'pregnant', add '1'
      // if the value contains 'breastfeeding', add '2'
      // if the value contains 'post natal', add '3'
      // if the value contains 'conceive', add '4'
      natalAnswerIndex.forEach(answer => {
        if (answer === 'No') {
          natalAnswers.push('0');
        } else if (answer.includes(`I'm pregnant`)) {
          natalAnswers.push('1');
        } else if (answer.includes(`I'm breastfeeding`)) {
          natalAnswers.push('2');
        } else if (answer.includes(`I'm postnatal`)) {
          natalAnswers.push('3');
        } else if (answer.includes(`I'm trying to conceive`)) {
          natalAnswers.push('4');
        }
      });

      if (conditionsAnswerIndex.length > 0) {
        healthConditions = conditionsAnswerIndex.join(', ');
      }

      if (manageConditionsAnswerIndex.length > 0) {
        manageHealthConditions = manageConditionsAnswerIndex.join(', ');
      }

      if (natalAnswerIndex.length > 0) {
        natal = natalAnswerIndex.join(', ');
      }

      if (selectedVitamins.length > 0) {
        let selelctedVitaminsArray = [];
        selectedVitamins.forEach(vitamin => {
          selelctedVitaminsArray.unshift(vitamin.value);
        });
        userSelectedVitamins = selelctedVitaminsArray.join(', ');
      }

      if (activeGoalsAnswer.length > 0) {
        goals = activeGoalsAnswer.join(', ');

        activeGoalsAnswer.forEach(priority => {
          switch (priority) {
            case 'Lose weight or tone up':
              prioritiesNumbers.push('1');
              break;
            case 'More energy':
              prioritiesNumbers.push('2');
              break;
            case 'Better immunity':
              prioritiesNumbers.push('3');
              break;
            case 'Better focus & memory':
              prioritiesNumbers.push('4');
              break;
            case 'Improve skin':
              prioritiesNumbers.push('5');
              break;
            case 'Better stress management & mental wellbeing':
              prioritiesNumbers.push('6');
              break;
            case 'Delay signs of aging':
              prioritiesNumbers.push('7');
              break;
            case 'Cardiovascular health':
              prioritiesNumbers.push('8');
              break;
            case 'Improve performance, endurance & recovery':
              prioritiesNumbers.push('9');
              break;
            case 'Healthier hair & nails':
              prioritiesNumbers.push('10');
              break;
            case 'Tackle excess hair':
              prioritiesNumbers.push('11');
              break;
            case 'Menstrual cycle health':
              prioritiesNumbers.push('12');
              break;
            case 'Reduce hot flashes & sweating':
              prioritiesNumbers.push('13');
              break;
            case 'Gut health & digestion':
              prioritiesNumbers.push('14');
              break;
            case 'Increase libido / sexual health':
              prioritiesNumbers.push('15');
              break;
            case 'Improve sleep quality':
              prioritiesNumbers.push('16');
              break;
            case 'Bone & joint health':
              prioritiesNumbers.push('17');
              break;
            default:
              break;
          }
        });
      }

      resultsLink += `fe=${firstName}`;
      resultsLink += `&priority=${prioritiesNumbers.join(',')}`;
      resultsLink += `&ae=${age}`;
      resultsLink += `&ge=${gender}`;
      resultsLink += `&selectedDiets=${dietsNumbers.join(',')}`;
      resultsLink += `&na=${natalAnswers}`;
      resultsLink += `&flavour=${flavour}`;
      resultsLink += `&coating=${coating}`;
      resultsLink += `&handles=${handlesNumbers}`;
      resultsLink += `&quizID=${quizID}`;

      const responses = {
        "responses": [
          {
            "question": "Name",
            "answers": `${firstName}`
          },
          {
            "question": "Gender",
            "answers": `${gender}`
          },
          {
            "question": "Race",
            "answers": `${race}`
          },
          {
            "question": "Age",
            "answers": `${age}`
          },
          {
            "question": "Energy slider value:",
            "answers": `${energySliderValue}`
          },
          {
            "question": "Activity slider value:",
            "answers": `${activitySliderValue}`
          },
          {
            "question": "Sleep slider value:",
            "answers": `${sleepSliderValue}`
          },
          {
            "question": "Screen slider value:",
            "answers": `${screenSliderValue}`
          },
          {
            "question": "What exercise:",
            "answers": `${exercise}`
          },
          {
            "question": "Travel:",
            "answers": `${travelAnswersIndex}`
          },
          {
            "question": "Do you follow a specific diet?:",
            "answers": `${specificDiet}`
          },
          {
            "question": "Do you have any dietary requirements?:",
            "answers": `${selectedDiets}`
          },
          {
            "question": "Do you get hungry or have dips in energy between meals?",
            "answers": `${hungryBetweenMeals}`
          },
          {
            "question": "Processes food frequency:",
            "answers": `${processedFoodAnswer}`
          },
          {
            "question": "Fruit & Veg frequency:",
            "answers": `${fruitVegAnswer}`
          },
          {
            "question": "How often do you drink alcohol?:",
            "answers": `${alcoholAnswersIndex}`
          },
          {
            "question": "Do you currently take vitamins?:",
            "answers": `${vitaminsAnswer}`
          },
          {
            "question": "Wear glasses or contacts?",
            "answers": `${glassesAnswer}`
          },
          {
            "question": "Do you suffer from any of these health conditions?:",
            "answers": `${healthConditions}`
          },
          {
            "question": "Quality of life slider value:",
            "answers": `${conditionsEffectSlider}`
          },
          {
            "question": "How do you manage your conditions?:",
            "answers": `${manageHealthConditions}`
          },
          {
            "question": "Are you pre/post natal, currently pregnant or breast feeding?",
            "answers": `${natal}`
          },
          {
            "question": "User seleced vitamins:",
            "answers": `${userSelectedVitamins}`
          },
          {
            "question": "Which of the below are your top two priorities in the upcoming months?",
            "answers": `${goals}`
          },
          {
            "question": "Flavour",
            "answers": `${flavour}`
          },
          {
            "question": "Coating",
            "answers": `${coating}`
          },
          {
            "question": "Results",
            "answers": `${handlesString}`
          },
          {
            "question": "Results link",
            "answers": `${resultsLink}`
          },
          {
            "question": "Quiz ID",
            "answers": `${quizID}`
          }
        ]
      };

      const cusomerData = { email: email }

      let submittedPayload = [];
      submittedPayload.push(cusomerData, responses);

      if (email !== '') {
        fetch(apiQuiz, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(submittedPayload),
        })
          .then(function (res) {
            resolve(res);
          })
          .catch(function (error) {
            reject(error);
          });
      }
    });
  }

  const nextPage = (continueIndex) => {
    let quizRoot = document.getElementById('root');
    quizRoot.scrollIntoView();

    switch (continueIndex) {
      case '0':
        setPageIndex(pageIndex + 1);
        break;
      case '1':
        setPageIndex(pageIndex + 1);
        // Create a QuizID if they show intent on continuing
        setQuizID(Math.floor(Date.now() + Math.random() * 100));
        break;
      case '2':
        setPageIndex(pageIndex + 1);
        break;
      case '3':
        setPageIndex(pageIndex + 1);
        break;
      case '4':
        setPageIndex(pageIndex + 1);
        if (localStorage.getItem('selectedNourishments')) {
          setSelectedVitamins(JSON.parse(localStorage.getItem('selectedNourishments')));
          toastHandler('Imported your selected nourishments', 5000);
          let userSelectedVitamins = JSON.parse(localStorage.getItem('selectedNourishments'));
          if (natalAnswerIndex.length !== 0 && natalAnswerIndex[0] !== 'No') {
            userSelectedVitamins = userSelectedVitamins.filter(vitamin => vitamin.value !== 'vitamin-a' && vitamin.value !== '5-htp');
          }
          setSelectedVitamins(userSelectedVitamins);
        }
        break;
      case '5':
        calculateWeights(weightingAnswers);
        break;
      default:
        break;
    }

  }

  const backPage = () => {
    let quizRoot = document.getElementById('root');
    quizRoot.scrollIntoView();
    if (pageIndex > 0) {
      setPageIndex(pageIndex - 1);
    }
  }

  return (
    <div id="coreQuiz" className={`kids-quiz kids-quiz--${pageIndex}`}>
      {pageIndex > 0 && (
        <Header pageIndex={pageIndex} backPage={backPage} />
      )}

      <TransitionGroup>
        <CSSTransition
          key={pageIndex}
          in={true}
          appear={true}
          timeout={1000}
          classNames="slide"
        >
          <>
            {{
              0: (
                <PageWelcome
                  firstName={firstName}
                  updateFirstName={updateFirstName}
                  nextPage={nextPage}
                />
              ),
              1: (
                <PageOne
                  renderGenderAnswers={renderGenderAnswers}
                  gender={gender}
                  onChangeNumber={onChangeNumber}
                  checkAge={checkAge}
                  age={age}
                  ageWarningMessage={ageWarningMessage}
                  renderRaceAnswers={renderRaceAnswers}
                  race={race}
                  nextPage={nextPage}
                  suitableAge={suitableAge}
                />
              ),
              2: (
                <PageTwo
                  energySliderValue={energySliderValue}
                  activitySliderValue={activitySliderValue}
                  sleepSliderValue={sleepSliderValue}
                  screenSliderValue={screenSliderValue}
                  handleSlider={handleSlider}
                  renderExerciseAnswers={renderExerciseAnswers}
                  exerciseAnswersIndex={exerciseAnswersIndex}
                  renderTravelAnswers={renderTravelAnswers}
                  travelAnswersIndex={travelAnswersIndex}
                  nextPage={nextPage}
                />
              ),
              3: (
                <PageThree
                  firstName={firstName}
                  gender={gender}
                  onSpecificDietClick={onSpecificDietClick}
                  specificDiet={specificDiet}
                  renderDietAnswers={renderDietAnswers}
                  dietAnswersIndex={dietAnswersIndex}
                  logHungryAnswer={logHungryAnswer}
                  hungryBetweenMeals={hungryBetweenMeals}
                  handleFoodRadios={handleFoodRadios}
                  processedFoodAnswer={processedFoodAnswer}
                  fruitVegAnswer={fruitVegAnswer}
                  renderAlcoholAnswers={renderAlcoholAnswers}
                  alcoholAnswersIndex={alcoholAnswersIndex}
                  vitaminsAnswer={vitaminsAnswer}
                  currentVitamins={currentVitamins}
                  nextPage={nextPage}
                />
              ),
              4: (
                <PageFour
                  gender={gender}
                  logGlassesAnswer={logGlassesAnswer}
                  glassesAnswer={glassesAnswer}
                  renderConditionsAnswers={renderConditionsAnswers}
                  conditionsAnswerIndex={conditionsAnswerIndex}
                  logIodineAnswer={logIodineAnswer}
                  iodineAnswer={iodineAnswer}
                  conditionsEffectSlider={conditionsEffectSlider}
                  handleSlider={handleSlider}
                  renderManageConditionsAnswers={renderManageConditionsAnswers}
                  manageConditionsAnswerIndex={manageConditionsAnswerIndex}
                  logMedicationAnswer={logMedicationAnswer}
                  medicationAnswer={medicationAnswer}
                  renderNatalAnswers={renderNatalAnswers}
                  natalAnswerIndex={natalAnswerIndex}
                  nextPage={nextPage}
                />
              ),
              5: (
                <PageFive
                  updateQuestionUrl={updateQuestionUrl}
                  natalAnswerIndex={natalAnswerIndex}
                  medicationAnswer={medicationAnswer}
                  selectedVitamins={selectedVitamins}
                  setSelectedVitamins={setSelectedVitamins}
                  selectFlavour={selectFlavour}
                  flavour={flavour}
                  selectCoating={selectCoating}
                  coating={coating}
                  renderGoalAnswers={renderGoalAnswers}
                  activeGoalsAnswer={activeGoalsAnswer}
                  setEmail={setEmail}
                  email={email}
                  consent={consent}
                  setConsent={setConsent}
                  nextPage={nextPage}
                />
              )
            }[pageIndex]}
          </>
        </CSSTransition>
      </TransitionGroup>

    </div>
  );
};

export default CoreQuiz;